<app-column [showHeader]="false">
  <app-column-group>
    <ng-container column-group-body>
      <div class="context text-14">
        <img src="/assets/images/logo-blue.svg" class="context__logo"/>
  
        Welcome to Human Studio! 
        <br/>Select a tool to get started. 
      </div>
    </ng-container>
  </app-column-group>
</app-column>
